var blue = '#1890ff';
var light_green = '#13c2c2';
var orange = '#fa8c16';
var pink = '#eb2f96';
var green = '#52c41a';
var red = '#f5222d';
export var orderStatusMap = {
  WAIT_PROCESS: {
    label: '待处理',
    color: pink,
    type: 'info'
  },
  WAIT_PAY: {
    label: '待支付',
    color: blue,
    type: 'primary',
    enable: true
  },
  WAIT_CONFIRM: {
    label: '待确认',
    color: orange,
    type: 'info'
  },
  WAIT_USE: {
    label: '待使用',
    color: blue,
    type: 'info'
  },
  PART_USE: {
    label: '部分使用',
    color: light_green,
    type: 'info'
  },
  WAIT_CONFIRM_WAIT_AUDIT: {
    label: '待审核',
    color: orange,
    type: 'info'
  },
  WAIT_USE_WAIT_AUDIT: {
    label: '待审核',
    color: orange,
    type: 'info'
  },
  PART_USE_WAIT_AUDIT: {
    label: '待审核',
    color: orange,
    type: 'info'
  },
  COMPLETE_WAIT_AUDIT: {
    label: '待审核',
    color: orange,
    type: 'info'
  },
  AUDITED: {
    label: '已审核',
    color: blue,
    type: 'info'
  },
  CLOSED: {
    label: '已关闭',
    color: '',
    type: 'info'
  },
  COMPLETE: {
    label: '已完成',
    color: blue,
    type: 'info'
  },
  CANCELED: {
    label: '已取消',
    color: '',
    type: 'info'
  }
};
export var ticketStatus = {
  WAIT_USE: {
    label: '待使用',
    color: blue
  },
  PART_USE: {
    label: '部分使用',
    color: blue
  },
  USED: {
    label: '已使用',
    color: ''
  },
  OUTOFDATE: {
    label: '已过期',
    color: ''
  },
  CANCELED: {
    label: '已取消',
    color: ''
  },
  WAIT_USE_CHANGING: {
    label: '改签中',
    color: orange
  },
  PART_USED_CHANGING: {
    label: '改签中',
    color: orange
  },
  USED_CHANGING: {
    label: '改签中',
    color: orange
  },
  CHANGED: {
    label: '已改签',
    color: light_green
  },
  REFUND_REQUEST: {
    label: '退款申请',
    color: orange
  },
  REFUND_WAIT_AUDIT: {
    label: '退款待审核',
    color: orange
  },
  REFUND_AUDIT_PASS: {
    label: '退款审核通过',
    color: orange
  },
  REFUND_MONEYBACKING: {
    label: '退款中',
    color: orange
  }
};
export var payStatus = {
  WAIT_PAY: {
    label: '待支付',
    color: blue
  },
  PAYED: {
    label: '已支付',
    color: green
  },
  REFUNDING: {
    label: '退款中',
    color: orange
  },
  REFUNDED: {
    label: '已退款',
    color: red
  },
  CLOSED: {
    label: '已关闭',
    color: ''
  }
};